import { useEffect } from "react";
import { Navigate, Route, Routes, useLocation } from "react-router-dom";
import { AppShell } from "./components/app-shell";
import { AccountPage } from "./pages/account-page";
import { AtlasPage } from "./pages/atlas-page";
import { FieldbookPage } from "./pages/fieldbook-page";
import { JourneyPage } from "./pages/journey-page";
import { NotFoundPage } from "./pages/not-found-page";

function ScrollToTop() {
  const { pathname } = useLocation();

  useEffect(() => {
    window.scrollTo(0, 0);
  }, [pathname]);

  return null;
}

export function App() {
  return (
    <>
      <ScrollToTop />
      <Routes>
        <Route element={<AppShell />}>
          <Route index element={<Navigate to="/atlas" replace />} />
          <Route path="/atlas" element={<AtlasPage />} />
          <Route path="/journeys/:journeyId/:stageId" element={<JourneyPage />} />
          <Route path="/fieldbook" element={<FieldbookPage />} />
          <Route path="/account" element={<AccountPage />} />
          <Route path="*" element={<NotFoundPage />} />
        </Route>
      </Routes>
    </>
  );
}
